module.exports = __webpack_public_path__ + "static/media/indications-for-use.525572c8.png";